import ContractTerminateModal from "./ContractTerminateModal";

export default ContractTerminateModal;
